export default "__VITE_ASSET__575b787b__"